import React, {Fragment} from 'react';
import {FieldArray, Formik} from "formik";
import * as Yup from "yup";
import {debounce} from 'lodash'
import {UncontrolledTooltip} from "reactstrap";


const BulkLocationEditorGeneralInternalUseOnlySchema = Yup.object().shape({
  directoryNameSearch: Yup.string(),
  notes: Yup.string(),
  clientLocationId: Yup.string(),
  alertEmailAddresses: Yup.array().of(
    Yup.string().email("Must be a valid email")
  ),
});

function BulkLocationEditorGeneralInternalUseOnly ({singleLocationMode, locationPatch, mergeIntoLocationPatch}) {
  const initialValues = {
    directoryNameSearch: !!locationPatch.brandMonitoring.listingMonitoring[0] ? locationPatch.brandMonitoring.listingMonitoring[0]["name"] : "",
    notes: !!locationPatch.notes ? locationPatch.notes : "",
    alertEmailAddresses: locationPatch.emails,
    clientLocationId: locationPatch.clientLocationId
  };

  let formInitialized = false;

  const handleFormUpdate = debounce((formValues, touched, errors) => {
    if (formInitialized) {

      const brandMonitoring = (!errors.directoryNameSearch && touched.directoryNameSearch) ? {
        listingMonitoring: [{
          name: formValues.directoryNameSearch
        }]
      } : {};

      const alertEmailAddresses = formValues.alertEmailAddresses.filter((email, index) => {
        return (!errors.alertEmailAddresses || !errors.alertEmailAddresses[index])
          && (touched.alertEmailAddresses && touched.alertEmailAddresses[index])
          || (initialValues.alertEmailAddresses.includes(email))
      });
       // Formatted for location patch

      const notes = (!errors.notes && touched.notes) ? formValues.notes : undefined;

      const clientLocationId = singleLocationMode ? formValues.clientLocationId : (
        (!errors.clientLocationId && touched.clientLocationId) ? formValues.clientLocationId : null
      );

      const merged = {
        brandMonitoring, // "Directory name search"
        emails: singleLocationMode ? formValues.alertEmailAddresses : alertEmailAddresses,
        notes,
        clientLocationId
      };

      mergeIntoLocationPatch(merged)

    } else {
      formInitialized = true;
      // don't want to update the patch until after the form has been initialized
    }
  }, 400);

  return <div className="card-spacer-top card-spacer-bottom">
    <h5>Internal Use Only</h5>
    <Formik
      initialValues={initialValues}
      validationSchema={BulkLocationEditorGeneralInternalUseOnlySchema}
    >
      {({
          values,
          touched,
          errors,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit
        }) => {

        handleFormUpdate(values, touched, errors);

        return <form className="card-spacer-top">
          <table style={{"width": "100%"}}>
            <tbody style={{"width": "100%"}}>
            <tr>
              <td style={{"width": "180px"}}>{/* Set width on first column so everything lines up nicely */}
                <label htmlFor="notes" style={{display: "block"}}>
                  Directory Name Search
                </label>
              </td>
              <td>
              <input
                type="text"
                name="directoryNameSearch"
                placeholder="Directory Name Search"
                value={values.directoryNameSearch}
                onChange={handleChange}
                onBlur={handleBlur}
                className={
                  "form-control" + (errors.directoryNameSearch && touched.directoryNameSearch ? " text-input error" : " text-input")
                }
              />
              </td>
            </tr>
            <tr>
              <td/>
              <td>
                <div className="invalid-feedback" style={{"display": "block", opacity: "0"}}>line spacer</div>
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="clientLocationId" style={{display: "block"}} className={(!singleLocationMode ? " cursor-not-allowed" : "")}>
                  Client Location ID
                </label>
              </td>
              <td>
                <input
                  disabled={!singleLocationMode}
                  id="clientLocationId"
                  placeholder="Client Location ID"
                  type="text"
                  value={values.clientLocationId}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={
                    "form-control" + (errors.clientLocationId && touched.clientLocationId ? " text-input error" : " text-input")
                    + (!singleLocationMode ? " cursor-not-allowed" : "")
                  }
                />
                {!singleLocationMode && <UncontrolledTooltip target="clientLocationId">
                  Client Location ID can only be edited for single locations.
                </UncontrolledTooltip>}
              </td>
            </tr>
            <tr>
              <td/>
              <td>
                {errors.clientLocationId && touched.clientLocationId ?
                  <div className="invalid-feedback" style={{"display": "block"}}>{errors.clientLocationId}</div> :
                  <div className="invalid-feedback" style={{"display": "block", opacity: "0"}}>line spacer</div>}
              </td>
            </tr>
            <tr>
              <td>Alert Email Addresses</td>
              <td />
            </tr>
          <FieldArray
            name="alertEmailAddresses"
            render={arrayHelpers => (
              <Fragment>
                {values.alertEmailAddresses.map((email, index) => (
                  <Fragment>
                  <tr key={index}>
                    <td style={{"textAlign": "right"}}>
                      <button type="button" className="btn btn-secondary" onClick={() => arrayHelpers.remove(index)}>
                        <i className="fas fa-trash-alt" />
                      </button>
                    </td>
                    <td>
                      <input
                        name={`alertEmailAddresses.${index}`}
                        placeholder="Email Address"
                        type="text"
                        value={values.alertEmailAddresses[index]}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={
                          "form-control" + (errors.alertEmailAddresses && errors.alertEmailAddresses[index] && touched.alertEmailAddresses && touched.alertEmailAddresses[index] ? " text-input error" : " text-input")
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td />
                    <td>
                      {!!errors.alertEmailAddresses && errors.alertEmailAddresses[index] && !!touched.alertEmailAddresses && touched.alertEmailAddresses[index] ?
                        <div className="invalid-feedback" style={{"display": "block"}}>{errors.alertEmailAddresses[index]}</div> :
                        <div className="invalid-feedback" style={{"display": "block", opacity: "0"}}>line spacer</div>}
                    </td>
                  </tr>
                  </Fragment>
                ))}

                <tr>
                  <td />
                  <td style={{"textAlign": "left"}}>
                    <button type="button" className="btn btn-secondary" onClick={() => arrayHelpers.push("")}>
                      <i className="far fa-plus" />
                    </button>
                  </td>
                </tr>
                <tr>
                  <td/>
                  <td>
                    <div className="invalid-feedback" style={{"display": "block", opacity: "0"}}>line spacer</div>
                  </td>
                </tr>
              </Fragment>
            )}
          />
          <tr>
            <td>
              <label htmlFor="notes" style={{display: "block"}}>
                Notes
              </label>
            </td>
            <td>
              <textarea
                name="notes"
                placeholder="Notes"
                value={values.notes}
                onChange={handleChange}
                onBlur={handleBlur}
                className={
                  "form-control" + (errors.notes && touched.notes ? " text-input error" : " text-input")
                }
              />
            </td>
          </tr>
            </tbody>
          </table>
        </form>
      }
      }
    </Formik>
  </div>
}

export default BulkLocationEditorGeneralInternalUseOnly;